module.exports = __webpack_public_path__ + "cw.svg?ae75cba57510891147b59f88c71d3584";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/cw.svg
// module id = 1060
// module chunks = 0